import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    InputBase,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    ThemeProvider,
    Tooltip,
} from '@mui/material';
import axios, { AxiosResponse } from 'axios';
import BasicTable, { Column } from '../../components/table';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { useNavigate } from 'react-router-dom';
import { BASEURL } from "../../constants/Common"
import getTheme from '../../theme/theme';
import { Vehiclelogfields } from '../../constants/Vehiclelogfields';
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';

export interface vehiclelogs {
    id: number | null;
    logno: string;
    assignedto: string;
    createddate: string;
    vehicle: string;
    purpose: string;
    startlocation: string;
    totaldistance: string;
    description: string;
    projectname: string;
    projectcode: string,
    createdby: string;
    remarks: string;
    attachments: File | null;
    attachments2: File | null;
    attachments3: File | null;
    attachments4: File | null;
    attachments5: File | null;
    attachments6: File | null;
    project_id: string;
    signature: string;
    initials: string;
}

export interface vehiclelog {
    id: number;
    logno: string;
    vehicle: string;
    purpose: string;
    assignedto: string;
    description: string;
    projectname: string;
    project_id: string;
    createdby: string;
    createddate: string;
    startlocation: string;
    totaldistance: string;
    remarks: string;
    attachments: string | null;
    signature: string;
    initials: string;
}

interface ProjectNames {
    id: number;
    project_name: string;
}

const VehiclelogsPage: React.FC<{ projectNameList: ProjectNames[] }> = ({ projectNameList }) => {
    const [vehiclelogs, setVehiclelogs] = useState<vehiclelogs[]>([]);
    const [filtereddata, setFiltereddata] = useState<vehiclelogs[]>([]);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [openPopup, setOpenPopup] = useState<boolean>(false);
    const [newdata, setNewdata] = useState<vehiclelogs>({
        id: null,
        logno: '',
        assignedto: '',
        createddate: '',
        vehicle: '',
        purpose: '',
        description: '',
        createdby: '',
        projectcode: '',
        totaldistance: '',
        startlocation: '',
        remarks: '',
        projectname: '',
        attachments: null,
        attachments2: null,
        attachments3: null,
        attachments4: null,
        attachments5: null,
        attachments6: null,
        project_id: '',
        signature: '',
        initials: ''
    });

    const [selecteddata, setSelecteddata] = useState<vehiclelogs | null>(null);
    const [editMode, setEditMode] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selectedProjectTitle = useSelector((state: RootState) => state.project.selectedProjectTitle);
    const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);
    const orgid = localStorage.getItem('orgid');
    const userid = localStorage.getItem('userid');
    const subscriptionstatus = localStorage.getItem('subscriptionstatus');
    const userraccess = JSON.parse("" + localStorage.getItem('userrole'));
    const moduleAccess = userraccess?.modulesaccess;
    const filteredRows = filtereddata.filter((data) =>
        selectedProjectTitle ? data.project_id === selectedProjectTitle : true
    );

    useEffect(() => {
        const fetchVehiclelogs = async () => {
            try {
                const url = `${BASEURL}/vehiclelogs/?orgid=${orgid}&userid=${userid}`;
                const response = await axios.get(url, {
                    headers: {
                        Accept: 'application/json',
                    },
                });
                setVehiclelogs(response.data.vehiclelogs);
            } catch (error) {
                console.log(error);
            }
        };
        fetchVehiclelogs();
        setProjectNamesData(projectNameList)
    }, []);

    useEffect(() => {
        if (selectedProjectTitle == '0') {
            setFiltereddata(vehiclelogs.filter((data) => (data.project_id !== selectedProjectTitle)));
        } else {
            setFiltereddata(vehiclelogs.filter((data) => (data.project_id === selectedProjectTitle)));
        }
    }, [vehiclelogs, searchTerm, selectedProjectTitle]);

    useEffect(() => {
        setFiltereddata(
            vehiclelogs.filter((data) =>
                data.logno.toLowerCase().includes(searchTerm.toLowerCase()) ||
                data.vehicle.toLowerCase().includes(searchTerm.toLowerCase()) ||
                data.totaldistance.toLowerCase().includes(searchTerm.toLowerCase()) ||
                data.purpose.toLowerCase().includes(searchTerm.toLowerCase()) ||
                data.assignedto.toLowerCase().includes(searchTerm.toLowerCase()) ||
                data.createddate.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [vehiclelogs, searchTerm]);

    useEffect(() => {
        fetchProjectnamesList();
    }, []);

    const fetchProjectnamesList = async () => {
        setProjectNamesData(projectNameList);
    };

    const columns: Column[] = [
        { id: 'logno', label: 'Log No', align: 'left' },
        { id: 'vehicle', label: 'Vehicle', align: 'left' },
        { id: 'totaldistance', label: 'Total Distance(kms)', align: 'left' },
        { id: 'purpose', label: 'Purpose', align: 'left' },
        { id: 'assignedto', label: 'Assigned To', align: 'left' },
        { id: 'createddate', label: 'Created Date', align: 'left' },
        { id: 'action', label: '', align: 'left' },
    ];

    const handleSearch = () => {
        console.log('Searching...');
    };

    const rows = filtereddata.map((data, index) => ({
        id: index + 1,
        logno: data.logno,
        vehicle: data.vehicle,
        totaldistance: data.totaldistance,
        purpose: data.purpose,
        assignedto: data.assignedto,
        createddate: data.createddate,
        action: (
            <Button variant='contained' onClick={() => handleViewSafetylog(data)}>
                {editMode ? 'View' : 'View'}
            </Button>
        ),
    }));

    const handleCreateNew = () => {
        navigate('/createnewvehiclelog', { state: { projectNameList: projectNameList } });
    };

    const handlePopupClose = () => {
        setOpenPopup(false);
        setEditMode(false);
    };

    const handleViewSafetylog = (data: vehiclelogs) => {
        setSelecteddata(data);
        navigate('/vehiclelog-details', { state: { logDetails: data, projectNamesData: projectNamesData } });
    };

    const handleFormChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;
        if (selecteddata) {
            setSelecteddata((prevdata) => ({
                ...prevdata!,
                [name]: value,
            }));
        } else {
            setNewdata((prevdata) => ({
                ...prevdata!,
                [name]: value,
            }));
        }
    };

    const handleBack = () => {
        setEditMode((prevEditMode) => !prevEditMode);
    };

    const handleFormSubmit = async () => {
        try {
            let response: AxiosResponse<vehiclelogs>;

            if (selecteddata && selecteddata.id !== null) {
                response = await axios.put(
                    BASEURL + `/vehiclelogs/${selecteddata.id}/`,
                    selecteddata,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
            } else {
                response = await axios.post(
                    BASEURL + '/vehiclelogs/create/',
                    newdata,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
            }

            if (!selecteddata || selecteddata.id === null) {
                setVehiclelogs((prevlogs) => [...prevlogs, response.data]);
                setOpenPopup(false);
            } else if (editMode) {
                setVehiclelogs((prevlogs) =>
                    prevlogs.map((log) =>
                        log.id === response.data.id ? response.data : log
                    )
                );
                setOpenPopup(true);
                setSelecteddata(response.data);
                setEditMode(false);
            }

            setNewdata({
                ...newdata,
                id: response.data.id,
            });

        } catch (error) {
            console.error('Error submitting:', error);
        }
    };

    return (
        <ThemeProvider theme={getTheme()}>
            {(subscriptionstatus === 'Active' || subscriptionstatus === 'Expired') ? (
                <Box sx={{ marginTop: '-60px' }}>
                    {subscriptionstatus === 'Expired' && (
                        <Typography variant="body1" >
                            <h3>Please renew your subscription.</h3>
                        </Typography>
                    )}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant='h5' component='div'>
                            Vehicle logs
                        </Typography>
                        <Box sx={{ marginLeft: 'auto' }}>
                            <Tooltip
                                title={
                                    moduleAccess === 'Owner' && subscriptionstatus === 'Active'
                                        ? ''
                                        : 'You do not have access to create a new feature'
                                }
                                placement="top"
                                arrow
                            >
                                <span>
                                    <div style={{ opacity: moduleAccess !== 'Owner' || subscriptionstatus !== 'Active' ? 0.5 : 1 }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                if (moduleAccess === 'Owner' && subscriptionstatus === 'Active') {
                                                    handleCreateNew();
                                                }
                                            }}
                                            sx={{ mr: 1 }}
                                        >
                                            Create New
                                        </Button>
                                    </div>
                                </span>
                            </Tooltip>
                        </Box>
                    </Box>

                    <Box sx={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                        <InputBase
                            placeholder='Search…'
                            inputProps={{ 'aria-label': 'search' }}
                            sx={{
                                marginRight: '10px',
                                border: '1px solid',
                                borderRadius: '4px',
                                paddingLeft: '10px',
                                ml: '5%',
                                height: '45px'
                            }}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <Button variant='contained' onClick={handleSearch}>
                            Search
                        </Button>
                    </Box>

                    <Box sx={{ marginTop: '20px' }}>
                        <BasicTable columns={columns} rows={rows} />
                    </Box>

                    <Dialog open={openPopup} onClose={handlePopupClose}>
                        <DialogTitle>
                            {selecteddata ? 'View Vehiclelog' : 'Create New Vehiclelog'}
                            <IconButton
                                aria-label='close'
                                onClick={handlePopupClose}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            {Vehiclelogfields.map((field) => (
                                <TextField
                                    key={field.name}
                                    fullWidth
                                    margin='normal'
                                    label={field.title}
                                    name={field.name}
                                    type={field.type}
                                    value={
                                        selecteddata
                                            ? selecteddata[field.name as keyof vehiclelogs]
                                            : newdata[field.name as keyof vehiclelogs] || ''
                                    }
                                    onChange={(e) => handleFormChange(e)}
                                    disabled={!editMode}
                                    required={field.isRequired}
                                />
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' onClick={editMode ? handleBack : handlePopupClose} color='primary'>
                                Cancel
                            </Button>
                            {!selecteddata && (
                                <Button onClick={handleFormSubmit} color='primary'>
                                    Save
                                </Button>
                            )}
                            {selecteddata && (
                                <>
                                    {!editMode && (
                                        <Button onClick={() => setEditMode(true)} color='primary'>
                                            Edit
                                        </Button>
                                    )}
                                    {editMode && (
                                        <>
                                            <Button onClick={handleBack} color='primary'>
                                                Back
                                            </Button>
                                            <Button onClick={handleFormSubmit} color='primary'>
                                                Submit
                                            </Button>
                                        </>
                                    )}
                                </>
                            )}
                        </DialogActions>
                    </Dialog>
                    <FloatingButton />
                </Box>
            ) : (
                <Typography variant="body1">
                    <h3>Please purchase a subscription plan.</h3>
                </Typography>
            )}
        </ThemeProvider>
    );
};

export default VehiclelogsPage;